import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "help-area" }
const _hoisted_2 = { class: "help__list" }
const _hoisted_3 = { class: "help__item sp-none" }
const _hoisted_4 = { class: "help__item sp-none" }
const _hoisted_5 = { class: "help__item sp-none" }
const _hoisted_6 = { class: "help__item sp-none" }
const _hoisted_7 = { class: "help__item sp-none" }
const _hoisted_8 = { class: "help__item sp-none" }
const _hoisted_9 = { class: "help__item sp-none" }
const _hoisted_10 = { class: "help__item sp-none" }
const _hoisted_11 = { class: "help__item sp-none" }
const _hoisted_12 = { class: "help__item sp-none" }
const _hoisted_13 = { class: "help__item sp-none" }
const _hoisted_14 = { class: "help__item sp-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#concept' : '/#concept',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" コンセプト ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#news' : '/#news',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" お知らせ ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#lesson' : '/#lesson',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" スケジュール ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#menu' : '/#menu',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" クラス紹介 ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#price' : '/#price',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" 料金 ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#flow' : '/#flow',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" 入会の流れ ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#qa' : '/#qa',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" よくある質問 ")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#staff' : '/#staff',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" スタッフ紹介")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: "/Facilittes",
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("施設紹介")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#info' : '/#info',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode(" ジム案内")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: _ctx.$route.path === '/' ? '#access' : '/#access',
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" アクセス")
          ])),
          _: 1
        }, 8, ["to", "onClick"])
      ]),
      _createElementVNode("li", _hoisted_14, [
        _createVNode(_component_router_link, {
          to: "/Contact",
          onClick: _ctx.onTapCloseButton
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" お問い合わせ ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}